import classNames from 'classnames';

const BASE = 'relative flex items-center justify-center overflow-hidden';
const FULLSCREEN = 'h-screen w-screen bg-black';

// The consumer `className` carries sizing (e.g. `h-[60vh] max-w-[90vw]`) that collides with the
// fullscreen `h-screen w-screen`. Both are single-class selectors, so stylesheet order — not the
// order they appear in the attribute — decides the winner; swap the classes instead of stacking them.
export function containerClassName(className: string | undefined, isFullscreen: boolean): string {
  return classNames(BASE, isFullscreen ? FULLSCREEN : className);
}
